// assets/cart-precheckout-guard.js

(() => {
  /**
   * @typedef {Window & { __cartPrecheckoutGuardInstalled?: boolean }} GuardWindow
   */

  /** @type {GuardWindow} */
  const w = window;

  // Evitar doble inicialización
  if (w.__cartPrecheckoutGuardInstalled) return;
  w.__cartPrecheckoutGuardInstalled = true;

  let pendingResubmit = false;

  /** @returns {HTMLFormElement | null} */
  const getForm = () => {
    const el = document.getElementById('cart-form');
    return el instanceof HTMLFormElement ? el : null;
  };

  /** @returns {HTMLElement | null} */
  const getComponent = () => {
    const el = document.querySelector('cart-precheckout');
    return el instanceof HTMLElement ? el : null;
  };

  /** @returns {HTMLElement | null} */
  const getCheckoutButton = () => {
    const el = document.getElementById('checkout');
    return el instanceof HTMLElement ? el : null;
  };

  /** @returns {HTMLInputElement | null} */
  const getRutInput = () => {
    const el = document.getElementById('billing_rut');
    return el instanceof HTMLInputElement ? el : null;
  };

  /**
   * @returns {Promise<HTMLElement | null>}
   */
  async function ensureComponentReady() {
    let el = getComponent();
    if (!el) return null;

    // @ts-ignore 
    if (typeof el.validateBeforeCheckout === 'function') return el;

    await customElements.whenDefined('cart-precheckout');
    el = getComponent();
    return el || null;
  }

  /**
   * @param {HTMLElement} precheckout
   * @returns {boolean}
   */
  function validate(precheckout) {
    // @ts-ignore
    if (typeof precheckout.validateBeforeCheckout === 'function') {
      // @ts-ignore
      return Boolean(precheckout.validateBeforeCheckout());
    }
    return true;
  }

  /**
   * @param {HTMLElement} precheckout
   * @returns {Promise<void>}
   */
  async function save(precheckout) {
    // @ts-ignore
    if (typeof precheckout.updateCartAttributesBeforeCheckout === 'function') {
      // @ts-ignore
      await precheckout.updateCartAttributesBeforeCheckout();
    }
    const rutInput = getRutInput();
    if (rutInput) rutInput.setCustomValidity('');
  }

  /**
   * Bloquea cualquier intento de checkout si el RUT no es válido/obligatorio.
   * @param {Event} event
   */
  async function guardCheckout(event) {
    if (pendingResubmit) return;

    const precheckout = await ensureComponentReady();
    if (!precheckout) return; 

    const isSubmit =
      event.type === 'submit' &&
      event.target instanceof HTMLFormElement &&
      event.target.id === 'cart-form';

    const isCheckoutInteraction = (() => {
      if (!(event.target instanceof Element)) return false;
      return Boolean(event.target.closest('#checkout'));
    })();

    if (!isSubmit && !isCheckoutInteraction) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const ok = validate(precheckout);
    if (!ok) return;

    await save(precheckout);
    const form = getForm();
    if (!form) return;

    pendingResubmit = true;
    try {
      const btn = getCheckoutButton();
      if (btn && 'requestSubmit' in form) {
        form.requestSubmit(btn);
      } else {
        form.submit();
      }
    } finally {
      setTimeout(() => {
        pendingResubmit = false;
      }, 0);
    }
  }

  document.addEventListener('pointerdown', guardCheckout, true);
  document.addEventListener('click', guardCheckout, true);
  document.addEventListener('submit', guardCheckout, true);
})();
